import { DailyStartDay } from './daily_start_day';
import { DailyStart } from './daily_start';
export class DailyStartVolume {
    constructor(data, config) {
        Object.defineProperty(this, "id", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "volumeNumber", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "finishedDays", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "totalDays", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "restOfDays", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "isCompleted", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "completedCount", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "minDuration", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "maxDuration", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "dailyStart", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "days", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.id = data.id;
        this.volumeNumber = data.volumeNumber;
        this.finishedDays = data.finishedDays;
        this.totalDays = data.totalDays;
        this.restOfDays = data.restOfDays;
        this.isCompleted = data.isCompleted;
        this.completedCount = data.completedCount;
        this.minDuration = data.minDuration;
        this.maxDuration = data.maxDuration;
        this.dailyStart = data.dailyStart ? new DailyStart(data.dailyStart, config) : null;
        this.days = data.days ? data.days.map((o) => new DailyStartDay(o, config)) : [];
    }
    get currentDay() {
        var _a;
        return (_a = this.days.find((day) => day.isCurrent)) !== null && _a !== void 0 ? _a : this.days[0];
    }
    nextVolumeNumber() {
        return this.volumeNumber + 1;
    }
}
